import ArrowsAnimation from "./Arrow";
import DownloadButton from "./DownloadButton";
import { useTranslation } from "react-i18next";

const AniTitle = () => {
  const { t } = useTranslation();

  return (
    <div
      className="animation__item__img"
      style={{
        backgroundImage: `url(${"/assets/images/title1.svg"})`,
      }}
    >
      <div className="animation__title">
        <div className="animation__title_big">
          <img id="img_logo__photo" src="/assets/images/main_logo.png" />
          {/* SPETTRUM */}
        </div>
        <div className="animation__title_medium">{t("AniTitleSub")}</div>
        <br />
        <div className="animation__title_small">
          {t("AniTitleDesc_1")}{" "}
          <span
            style={{
              textDecoration: "underline",
              textUnderlinePosition: "under",
            }}
          >
            {t("AniTitleDesc_2")}
          </span>{" "}
          {t("AniTitleDesc_3")}
        </div>
      </div>
      <DownloadButton />
      <ArrowsAnimation color="#fff" />
    </div>
  );
};

export default AniTitle;
